import DialogStyles from "../../../../styles/components/DialogStyles";

const { StyledModalTitle, StyledModalText } = DialogStyles;

const HeaderGenerateTach: React.FC = () => {
    return (
        <>
            <StyledModalTitle style={{ fontSize: "22px" }}>
                Gerar TACH
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                Preencha os campos corretamente para gerar o documento.
            </StyledModalText>
        </>
    );
};

export default HeaderGenerateTach;
